import * as THREE from "three";
import {Vector3} from "three";
import DecoElement from "./decoElement";
import MeshUtils from "../utils/meshUtils";

export default class DecoManager {
    static init({scene, blueprints}){
        this.scene = scene;
        this.blueprints = blueprints;

        this.decoElements = [];
        this.decoDistance = 5;
        this.spawnDistance = 5;

        const initialElements = 10;

        for(let i = 1; i < initialElements; i++){
            this.lastElementZ = i * this.decoDistance;
            this.spawnDeco(this.lastElementZ);
        }
        this.lastElementZ += this.decoDistance;
    }

    static getRandomScale(){
        return 1 + Math.random();
    }


    static randomizeNumber(num) {
        return -0.5 + num + Math.random();
    }

    static spawnDeco(z){
        const position = new THREE.Vector3(this.randomizeNumber(-6), 0, -2);

        let blueprintIndex = Math.floor(Math.random() * this.blueprints.length);

        const decoElement = DecoElement.createMesh({
            blueprint: this.blueprints[blueprintIndex],
            position,
            scale: this.getRandomScale()
        });
        //this.decoElements.push(decoElement);

        const positionLeft = new THREE.Vector3(this.randomizeNumber(6), 0, -2);

        blueprintIndex = Math.floor(Math.random() * this.blueprints.length);
        const decoElementLeft = DecoElement.createMesh({
            blueprint: this.blueprints[blueprintIndex],
            position: positionLeft,
            scale: this.getRandomScale()
        });
        //this.decoElements.push(decoElementLeft);

        const positionOuter = new THREE.Vector3(-12, 0, 2);

        blueprintIndex = Math.floor(Math.random() * this.blueprints.length);
        const decoElementOuter = DecoElement.createMesh({
            blueprint: this.blueprints[blueprintIndex],
            position: positionOuter,
            scale: this.getRandomScale()
        });
        //this.decoElements.push(decoElementOuter);

        const positionLeftOuter = new THREE.Vector3(12, 0, 2);

        blueprintIndex = Math.floor(Math.random() * this.blueprints.length);
        const decoElementLeftOuter = DecoElement.createMesh({
            blueprint: this.blueprints[blueprintIndex],
            position: positionLeftOuter,
            scale: this.getRandomScale()
        });
        //this.decoElements.push(decoElementLeftOuter);

        const mergedMesh = MeshUtils.mergeMeshes([decoElement, decoElementLeft, decoElementLeftOuter, decoElementOuter]);
        const mergedDecoElement = new DecoElement({
            scene: this.scene, mesh: mergedMesh, position: new Vector3(0,0,z), scale: 1
        })
        this.decoElements.push(mergedDecoElement);
    }

    static moveZ(amount){
        this.spawnDistance += amount;
        if(this.spawnDistance <= this.decoDistance){
            const overflow = -this.spawnDistance;
            this.spawnDistance = this.decoDistance - overflow;
            this.spawnDeco(this.lastElementZ);
        }

        const decoElementsToDelete = [];
        this.decoElements.forEach(o => {
            o.moveTo(
                new Vector3(
                    o.mesh.position.x,
                    o.mesh.position.y,
                    o.mesh.position.z + amount
                )
            )
            if(o.mesh.position.z < -10){
                decoElementsToDelete.push(o);
            }
        })
        this.decoElements = this.decoElements.filter(o => !decoElementsToDelete.includes(o));
        decoElementsToDelete.forEach(o => o.destroy())
    }

    static getDecoElements(){
        return this.decoElements;
    }

    static createDeco({position, blueprint, scale}){
        return new DecoElement({
            scene: this.scene,
            blueprint,
            position,
            scale,
        })
    }
}